"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildBasicProfilePayload;

var _lodash = _interopRequireDefault(require("lodash.get"));

var _buildOrganisationInfoPayload = _interopRequireDefault(require("../../../utils/buildOrganisationInfoPayload"));

var _utils = require("../../../utils");

var _getDefaultAlias = _interopRequireDefault(require("./getDefaultAlias"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function getParentOrganisation(parentOrganisation, organisations) {
  return parentOrganisation && organisations.find(function (organisation) {
    return organisation.name === parentOrganisation;
  });
}

function replaceParentOrganisationWithId(organisation) {
  var parentOrganisation = organisation.parentOrganisation,
      organisationFields = _objectWithoutProperties(organisation, ["parentOrganisation"]);

  return _objectSpread({}, organisationFields, {
    parentOrganisationId: (0, _lodash.default)(parentOrganisation, 'organisationId', parentOrganisation)
  });
}

function buildBasicProfilePayload(originalOrganisation, state, organisations) {
  var isValidAddress = state.isValidAddress,
      isValidOrganisationName = state.isValidOrganisationName,
      parentOrganisation = state.parentOrganisation,
      imageFile = state.imageFile,
      imageUrl = state.imageUrl,
      error = state.error,
      saving = state.saving,
      aliasChanged = state.aliasChanged,
      organisationId = state.organisationId,
      newOrganisation = _objectWithoutProperties(state, ["isValidAddress", "isValidOrganisationName", "parentOrganisation", "imageFile", "imageUrl", "error", "saving", "aliasChanged", "organisationId"]);

  var defaultedOriginalOrganisation = originalOrganisation || {};
  var parentOrganisationEntity = getParentOrganisation(parentOrganisation, organisations);

  var payload = _objectSpread({}, newOrganisation, {
    alias: newOrganisation.alias || (0, _getDefaultAlias.default)(newOrganisation.name),
    parentOrganisation: parentOrganisationEntity,
    // If organisation already exists we can set the bucket key in this payload
    imageUrl: imageFile && organisationId ? (0, _utils.buildBucketKey)('organisation', organisationId, 'profileimage') : defaultedOriginalOrganisation.imageUrl
  });

  return (0, _buildOrganisationInfoPayload.default)(replaceParentOrganisationWithId(defaultedOriginalOrganisation), replaceParentOrganisationWithId(payload));
}